module.exports = __webpack_public_path__ + "img/invitation_platform.2662c211.png";